(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("mhc-server", [], factory);
	else if(typeof exports === 'object')
		exports["mhc-server"] = factory();
	else
		root["mhc-server"] = factory();
})(global, () => {
return 